<template>
  <div v-if="detail != ''" class="container">
    <h3>{{ detail.brand_name }}</h3>
    <ul>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>单价：</label>
        <p>{{ detail.price }}</p>
      </li>
      <li>
        <label>单位类型：</label>
        <p v-show="detail.count_type == 1">单个装</p>
        <p v-show="detail.count_type == 2">整盒装</p>
      </li>
      <li>
        <label>对应单个：</label>
        <p v-show="detail.count_type == 2 && detail.small_brand_name == ''">
          未绑定
        </p>
        <p v-show="detail.count_type == 2 && detail.small_brand_name != ''">
          {{ detail.small_brand_name }}
        </p>
      </li>
      <li>
        <label>换算数量：</label>
        <p>{{ detail.count_num }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p v-show="detail.is_upper == 1">下架</p>
        <p v-show="detail.is_upper == 2">上架</p>
      </li>
      <li
        v-show="detail.brand_firm_arr != undefined"
        v-for="(element, index) in detail.brand_firm_arr"
        :key="index"
      >
        <p v-show="element.firm_id == 1">{{ "易触编号：" + element.number }}</p>
        <p v-show="element.firm_id == 2">
          {{ "华屹1编号：" + element.number }}
        </p>
        <p v-show="element.firm_id == 3">
          {{ "华屹2编号：" + element.number }}
        </p>
        <p v-show="element.firm_id == 4">
          {{ "卡游编号：" + element.number }}
        </p>
      </li>
      <li>
        <label>货道容量：</label>
        <p>{{ detail.ky_container }}</p>
      </li>
      <li>
        <label>创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.update_time }}</p>
      </li>
      <li v-if="images != ''">
        <label>图片：</label>
        <viewer :images="images" class="imgStyle">
          <img
            v-for="(src, k) in images"
            v-show="k == 1"
            :src="src"
            :key="src.id"
          />
        </viewer>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
      images: []
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      // console.log(this.detail);
      if (this.detail.imageUrl != undefined && this.detail.imageUrl != "") {
        this.images = Object.values(this.detail.imageUrl);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 3.2%;
  h3 {
    font-size: 20px;
    margin: 20px 0;
  }
  ul {
    li {
      display: inline-block;
      width: 33.3%;
      vertical-align: top;
      margin-bottom: 20px;
      label,
      p {
        display: inline-block;
        vertical-align: top;
      }
      .imgStyle {
        display: inline-block;
        vertical-align: top;
      }
      img {
        width: 100px;
        height: 100px;
        border: 1px solid #ededed;
        object-fit: cover;
      }
    }
  }
}
</style>
